import * as React from "react";
import { SourcePicker, useSource } from "..";
export function LinkedSourcePicker({ style, asButton, showLine, defaultExpanded, }) {
    const [source, setSource, sources] = useSource();
    if (!sources || sources.length === 0) {
        return null;
    }
    return (React.createElement(SourcePicker, { value: source, onChange: (source) => setSource(source.id), style: style, asButton: asButton, showLine: showLine, defaultExpanded: defaultExpanded }));
}
//# sourceMappingURL=LinkedSourcePicker.js.map